import React from 'react';

const Header = () => (
  <header className="movie-card-header ">
    <h1 className="page-title"> <span>N</span>  Movies</h1>
  </header>);

export default Header;
